<div class="p-3 d-flex gap-3 flex-column overtime-summary-activity" *transloco="let t; prefix: 'overtimeManagement'">
  <div class="d-flex align-items-center overtime-summary__activity-header">
    <div class="flex-grow-1">
      <h4 class="fw-bold">{{ t('hours.title') }}</h4>
    </div>
    <div class="w-auto">
      <svg [ngbTooltip]="t('hours.tooltip')" placement="left"
        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <circle cx="8" cy="8" r="7" fill="none" stroke="#4D4749" stroke-width="2" />
        <line x1="8" y1="12" x2="8" y2="8" stroke="#4D4749" stroke-width="2" />
        <circle cx="8" cy="5" r="1" fill="#4D4749" />
      </svg>
    </div>
  </div>

  <div class="row gx-1">
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('hours.overtimeHours')"
        [value]="overtimeHoursSummary.overtimeHoursCurrentValue"
        [difference]="overtimeHoursSummary.overtimeHoursDifference"
        [percentageDifference]="overtimeHoursSummary.overtimeHoursPercentageDifference" [dateInterval]="dateInterval">
      </app-metric-block>
    </div>
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('hours.weeklyAverage')"
        [value]="overtimeHoursSummary.weeklyAverageCurrentValue"
        [difference]="overtimeHoursSummary.weeklyAverageDifference"
        [percentageDifference]="overtimeHoursSummary.weeklyAveragePercentageDifference" [dateInterval]="dateInterval">
      </app-metric-block>
    </div>
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('hours.monthlyAverage')"
        [value]="overtimeHoursSummary.monthlyAverageCurrentValue"
        [difference]="overtimeHoursSummary.monthlyAverageDifference"
        [percentageDifference]="overtimeHoursSummary.monthlyAveragePercentageDifference" [dateInterval]="dateInterval">
      </app-metric-block>
    </div>
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('hours.compensation')"
        [value]="formatCost(overtimeHoursSummary.compensationCurrentValue)"
        [difference]="overtimeHoursSummary.compensationDifference"
        [percentageDifference]="overtimeHoursSummary.compensationPercentageDifference" [dateInterval]="dateInterval">
      </app-metric-block>
    </div>
  </div>
</div>